import TableStriped from './TableStriped';

export default TableStriped;
